export const KEYBOARD_ACTIONS = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ENTER: 'Enter',
};

export interface AutoCompleteSuggestion {
  value: string | number;
  label: string;
}

export const handleArrowKeys = (keyboardAction: string = '', focusedIndex: number, value: string = '', originalValue: string = '', suggestions: AutoCompleteSuggestion[] = []) => {
  switch (keyboardAction) {
    case KEYBOARD_ACTIONS.ARROW_UP:
      if (focusedIndex === -1) {
        focusedIndex = suggestions?.length;
        value = originalValue;
      } else if (focusedIndex < -1) {
        focusedIndex = suggestions?.length - 1;
        value = suggestions[focusedIndex]?.label;
      } else {
        value = suggestions[focusedIndex]?.label;
      }
      break;
    case KEYBOARD_ACTIONS.ARROW_DOWN:
      if (focusedIndex === suggestions?.length) {
        focusedIndex = -1;
        value = originalValue;
      } else if (focusedIndex > suggestions?.length) {
        focusedIndex = 0;
        value = suggestions[focusedIndex]?.label;
      } else {
        value = suggestions[focusedIndex]?.label;
      }
      break;
    default:
      break;
  }

  return [value, focusedIndex];
};
